import { Component, Input, Output, EventEmitter } from '@angular/core';

import { Store } from '@src/store';
import { DialogManagerService } from '@src/services';
import { TranslatePipe } from '@app/shared/pipes/translate.pipe';
import { policyEngineActions } from '@src/store/reducers/policyEngineReducer';

import * as _ from 'lodash';
import $ from 'jquery';

@Component({
    selector: 'policy',
    template: require('./policy.component.html'),
    styles: [require('./policy.component.scss')]
})
export class PolicyComponent {
    @Input() public processData: any;
    @Input() public indexInList: any;

    @Input() public get policy() {
        return this._policy;
    }

    public set policy(value) {
        if (value) {
            this._tempPolicy = this.deepCopy(value);
        }
        this._policy = value;
    }

    @Output() public onDuplicate = new EventEmitter<any>();
    @Output() public onDelete = new EventEmitter();

    private _policy: any;
    private _tempPolicy: any;
    private copyPolicy: any;

    constructor(
        private store: Store,
        private dialogManagerService: DialogManagerService,
        private translatePipe: TranslatePipe) {
    }

    public compareByKey(obj1: any, obj2: any) {
        return obj1 && obj2 && obj1.Key === obj2.Key;
    }

    public duplicate() {
        this.copyPolicy = Object.assign({}, this._policy);
        this.copyPolicy.relationship = this.copyPolicy.relationship.key;
        this.copyPolicy.rules = [];
        if (this.copyPolicy.selectedRulesIntoOther) {
            this.copyPolicy.selectedRulesIntoOther.forEach((cat: any) => {
                cat.rules = cat.children;
                let result = null;
                if (cat.rules) {
                    result = cat.rules.filter((rule: any) => rule.selected);
                }
                if (result) {
                    result.isEnabled = 1;
                    this.copyPolicy.rules.push(result);
                }
            });
        }
        this.copyPolicy.rules = this.copyPolicy.rules.reduce((a: any, b: any) => a.concat(b), []);
        delete this.copyPolicy.selectedRulesIntoOther;
        delete this.copyPolicy.dbs;
        delete this.copyPolicy.enviromentTypes;
        this.onDuplicate.emit(this.copyPolicy);
    }

    private async isPolicyValid() {
        const translations = await this.translatePipe.transform([
            'ERROR', 'ERROR_NO_NAME', 'ERROR_NO_ENV_TYPE', 'ERROR_NO_RULES'
        ]);
        if (this.copyPolicy.name === '') {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_NAME']
            });
            return false;
        }
        if (this.copyPolicy.environmentTypes.length <= 0) {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_ENV_TYPE']
            });
            return false;
        }
        if (this.copyPolicy.rules.length <= 0) {
            this.dialogManagerService.showErrorDialog({
                title: translations['ERROR'],
                text: translations['ERROR_NO_RULES']
            });
            return false;
        }
        return true;
    }

    public async savePolicy() {
        this.copyPolicy = Object.assign({}, this._policy);
        this.copyPolicy.relationship = this.copyPolicy.relationship.key;
        this.copyPolicy.rules = [];
        if (this.copyPolicy.selectedRulesIntoOther) {
            this.copyPolicy.selectedRulesIntoOther.forEach((cat: any) => {
                cat.rules = cat.children;
                let result = null;
                if (cat.rules) {
                    result = cat.rules.filter((rule: any) => rule.selected);
                }
                if (result) {
                    result.forEach((rule: any) => rule.isEnabled = 1);
                    this.copyPolicy.rules.push(result);
                }
            });
        }
        this.copyPolicy.rules = this.copyPolicy.rules.reduce((a: any, b: any) => a.concat(b), []);
        const translations = await this.translatePipe.transform(['ERROR', 'UNEXPECTED_ERROR']);
        if (await this.isPolicyValid()) {
            delete this.copyPolicy.selectedRulesIntoOther;
            delete this.copyPolicy.dbs;
            delete this.copyPolicy.enviromentTypes;

            if (this._policy.isNew) {
                this._policy.id = 0;
                const response = await this.store.dispatch({
                    type: policyEngineActions.ADD_POLICY,
                    payload: { policyData: this.copyPolicy }
                });
                if (response) {
                    this._policy = this.processData.policies[0];
                    await this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: translations['ERROR'],
                        text: translations['UNEXPECTED_ERROR']
                    });
                }
            } else {
                const expetedElement = `ul.dbm-list > li:nth-child(${this.indexInList + 1})`;
                const response = await this.store.dispatch({
                    type: policyEngineActions.SAVE_POLICY,
                    payload: { policyId: this._policy.id, policyData: this.copyPolicy }
                });
                if (response) {
                    await this.store.dispatch({ type: policyEngineActions.GET_POLICIES });
                    setTimeout(() => { $(expetedElement).click(); }, 50);
                } else {
                    this.dialogManagerService.showErrorDialog({
                        title: translations['ERROR'],
                        text: translations['UNEXPECTED_ERROR']
                    });
                }
            }
        }
    }

    public cancel() {
        if (this._policy.isNew) {
            this._policy = this.deepCopy(this._tempPolicy);
            this.processData.policies[this.indexInList].name = this._policy.name;
        } else {
            setTimeout(() => { $('.policy-container').find('ul.dbm-list > li.selected').click(); }, 50);
        }
    }

    private deepCopy(obj: any) {
        if (!obj) {
            return obj;
        }

        return _.cloneDeep(obj);
    }
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/authorized/policyEngine/policy-management/policy/policy.component.ts